import "../../globals";
import React from "react";
import translate from "@deosite/helpers/langLibrary";
import { RichText } from "prismic-reactjs";

import Box from "@commerce-ui/core2/Box";
import Grid from "@commerce-ui/core2/Grid";
import Container from "@commerce-ui/core2/Container";

import PageContainer from "../../containers/UI/PageContainer";
import SideStickyMenu from "../../components/SideStickyMenu";
import FaqRaw from "../../components/FaqRaw";
import MetaTags from "../../components/MetaTags";

import {
  usePrismicInfoPage,
  fetcher as prismicInfoPageFetcher
} from "@deosite/api/hooks/prismic/usePrismicInfoPage";

const InfoPage = props => {
  const { initialPrismicResponse, initialUid, lang } = props;

  const translations = {
    seoDescription: translate("Default seo description"),
    seoTitle: translate("Default seo title")
  };

  const { data: prismicResponse } = usePrismicInfoPage(
    initialUid,
    lang,
    initialPrismicResponse
  );

  const faq = prismicResponse?.faq && (
    <Box>
      <Box sx={{ height: "1px", bg: "neutral" }} />
      {prismicResponse.faq.map(
        (question, index) =>
          question && (
            <FaqRaw
              key={`faqRaw-${index}`}
              question={question.question}
              answer={question.answer}
            />
          )
      )}
    </Box>
  );

  return (
    <>
      <MetaTags
        description={
          prismicResponse?.seoDescription
            ? prismicResponse.seoDescription
            : translations.seoDescription
        }
        title={
          prismicResponse?.seoTitle
            ? prismicResponse.seoTitle
            : translations.seoTitle
        }
      />
      <PageContainer footerContent={props.footerContent}>
        <Container sx={{ mt: [0, null, "s6", null] }}>
          <Grid cols={[24, null, 20, null]}>
            {prismicResponse?.content && (
              <Box
                sx={{
                  gridColumn: ["1 / span 24", null, "1 / span 10", null],
                  order: [2, null, 1, null]
                }}
              >
                <Box
                  sx={{
                    color: "main",
                    font: "base",
                    img: { width: "100%" },
                    a: {
                      color: "main",
                      textDecoration: "none"
                    },
                    h1: {
                      font: "xl",
                      m: 0
                    }
                  }}
                >
                  {prismicResponse?.content &&
                    prismicResponse.content.map((paragraph, index) => {
                      return (
                        <Box key={`paragraph-${index}`}>
                          {index === 1 && faq}
                          <Box
                            key={`paragraphText-${index}`}
                            sx={{ my: "s10" }}
                          >
                            {RichText.render(paragraph.text)}
                          </Box>
                        </Box>
                      );
                    })}
                </Box>
              </Box>
            )}
            <Box
              sx={{
                gridColumn: ["1 / span 24", null, "11 / span 10", null],
                order: [1, null, 2, null],
                pl: [0, null, "10%", "20%"]
              }}
            >
              {prismicResponse?.menu?.length > 0 && (
                <SideStickyMenu
                  menuData={prismicResponse.menu}
                  initialActiveRow={initialUid}
                />
              )}
            </Box>
          </Grid>
        </Container>
      </PageContainer>
    </>
  );
};

InfoPage.getInitialProps = async props => {
  try {
    const uid = props.query.info;
    const response = await prismicInfoPageFetcher(uid, props.language);

    return {
      initialPrismicResponse: response,
      initialUid: uid,
      lang: props.language
    };
  } catch (error) {
    console.error(error);
    return error;
  }
};

export default InfoPage;
